import { render, staticRenderFns } from "./DownloadNoteHistoryModal.vue?vue&type=template&id=ac8fd3ee&scoped=true&"
import script from "@/scripts/Notes/NotesLanding/components/DownloadNoteHistoryModal.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NotesLanding/components/DownloadNoteHistoryModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8fd3ee",
  null
  
)

export default component.exports